import { useQuery, keepPreviousData } from "@tanstack/react-query";
import qs from "qs";
import api from "@services/api";

async function fetchCustomerFeedback(filters, page, pageSize) {
  const query = qs.stringify(
    { ...filters, page, page_size: pageSize },
    { encodeValuesOnly: true }
  );
  const { data } = await api.get(`/customer-feedback?${query}`);
  return data;
}

export function useCustomerFeedbackQuery(filters, page, pageSize) {
  return useQuery({
    queryKey: ["customers", "feedback", filters, page, pageSize],
    queryFn: () => fetchCustomerFeedback(filters, page, pageSize),
    placeholderData: keepPreviousData
  });
}

